import PropTypes from 'prop-types'
import React from 'react'
import FooterButton from '@/checkout-instore-legacy/components/Commons/Elements/FooterButton'
import Topbar from '@/checkout-instore-legacy/components/Commons/Topbar'
import classNames from 'classnames'

const Modal = ({
  showTitleBar,
  title,
  fullScreen,
  keepContentSize,
  children,
  onClose,
  onClickBackButton,
  onSubmit,
  isButtonInline,
  submitButtonLabel,
  minHeight,
  backgroundImage,
  fatal,
}) => {
  const btnClass = isButtonInline ? 'w-100' : ''
  const topbarMode = keepContentSize ? 'normal' : 'modal'

  return (
    <div
      className="flex-l flex-column-l aspect-ratio--object items-center-l justify-center-l"
      style={{ minHeight }}
    >
      <div
        className="dn db-l bg-black-60 aspect-ratio--object"
        onClick={fatal ? null : onClose}
      />
      <div
        className={`flex flex-column aspect-ratio--object z-9999 bg-base overflow-auto ${classNames(
          { 'full-screen': fullScreen }
        )} ${
          keepContentSize ? '' : 'h-auto-l w-50-l mw7-l relative-l pa4 pa6-l'
        }`}
        style={!showTitleBar ? { minHeight, backgroundImage } : { minHeight }}
      >
        {showTitleBar && (
          <Topbar
            title={title}
            onBack={onClickBackButton}
            rightButton={fatal ? null : 'close'}
            onClose={onClose}
            mode={topbarMode}
          />
        )}

        <div className="relative flex-auto overflow-auto momentum flex flex-column">
          {children}
        </div>

        {onSubmit ? (
          <div className={`flex-none ${isButtonInline ? 'tc-l' : ''} `}>
            <FooterButton
              id="close-modal"
              kind="success"
              size="lg"
              modal
              inline={isButtonInline}
              className={btnClass}
              onClick={onSubmit}
            >
              {!submitButtonLabel ? 'Confirmar' : submitButtonLabel}
            </FooterButton>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  )
}

Modal.defaultProps = {
  fullScreen: false,
  showTitleBar: true,
}

Modal.propTypes = {
  title: PropTypes.string,
  showTitleBar: PropTypes.bool,
  fullScreen: PropTypes.bool,
  keepContentSize: PropTypes.bool,
  children: PropTypes.node,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  onClickBackButton: PropTypes.func,
  isButtonInline: PropTypes.bool,
  submitButtonLabel: PropTypes.string,
  minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  backgroundImage: PropTypes.string,
  fatal: PropTypes.bool,
}

export default Modal
